import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import SupplierEditData from "../../../components/SupplierEdit/SupplierEditData";
import SupplierFormData from "../../../components/SupplierInformationData/SupplierFormData";
// import "../../.././assets/css/customize.css";
import PayBillsEditData from "../../../components/SupplierPayBillsEditData/PayBillsEditData";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";
import config from "../../../config/config";
import axios from "axios";
import SupplierStatement from "../../../components/Supplier/SupplierStatement";
import { Noimage } from "../../../common/imagePath";
import MissingTransaction from "../../../components/Modal/MissingTransaction";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import QuickbookSyncMessageComponent from "../../../components/StoreConfig/QuickbookSyncMessageComponent";

const ManageSuppliers = () => {
  const { CurrencySymbol, FractionDigits } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [supplier, setSupplier] = useState(false);
  const [receivingListId, setReceivingListId] = useState(4);
  const [receivingData, setReceivingData] = useState(true);
  const [payBillsData, setPayBillsData] = useState(false);
  const [comment, setComment] = useState(false);
  const [internalnotes, setInternalNotes] = useState(false);
  const [contenttype, setContentType] = useState("");
  const [content, setContent] = useState("");
  const [supplierdetails, setSupplierDetails] = useState({});
  const [statement, setStatement] = useState(false);
  const [showErrorOfLength, setShowErrorOfLength] = useState(false);
  const [showErrorOfLengthNote, setShowErrorOfLengthNote] = useState(false);
  const [QuickBookId, setQuickBookId] = useState(0);

  const paramObject = useParams();
  const {missingtransaction,missingtransactions,QuickBookVendors, AllowQBSync} = useContext(AppContext)
  useEffect(() => {
    if(paramObject.id > 0){
      let reqob = {
       Module: "suppliers",
       Id : paramObject.id
      }
      missingtransaction(reqob)
     }
  },[])
  let ID = paramObject.id;
  const navigate = useNavigate();

  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");

  const handleStatement = () => {
    setStatement(true);
    setInternalNotes(false);
    setComment(false);
    setSupplier(false);
    setPayBillsData(false);
    setReceivingData(false);
  };

  const handleToggle = (id) => {
    setStatement(false);
    setSupplier(false);
    setPayBillsData(false);
    setReceivingListId(id);
    setReceivingData(true);
    setInternalNotes(false);
    setComment(false);
  };

  const handleComment = () => {
    setStatement(false);
    setComment(true);
    setSupplier(false);
    setPayBillsData(false);
    setReceivingData(false);
    setInternalNotes(false);
  };

  const handleNotes = () => {
    setInternalNotes(true);
    setStatement(false);
    setComment(false);
    setSupplier(false);
    setPayBillsData(false);
    setReceivingData(false);
  };

  const handleClick = () => {
    setSupplier(false);
    setStatement(false);
    setReceivingData(false);
    setPayBillsData(true);
    setComment(false);
    setInternalNotes(false);
  };

  const handleCommentAndNotes = (e) => {
    console.log(e.target.value, "length of comment");
    if (e.target.value.length >= 255) {
      e.target.name == "COMMENTS"
        ? setShowErrorOfLength(true)
        : e.target.name == "NOTES" && setShowErrorOfLengthNote(true);
    } else {
      setShowErrorOfLength(false);
      setShowErrorOfLengthNote(false);
      setContentType(e.target.name);
      setContent(e.target.value);
    }
  };

  // console.log("params_id:---", ID);

  const commentandnotes = {
    id: ID,
    content: content,
    contenttype: contenttype,
    loginuserid: Id,
    QuickBookId: QuickBookId,
  };

  console.log(commentandnotes);

  useEffect(() => {
    // Binding Customer Fields

    setLoading(true);

    axios
      .get(`${config.suppliersBaseUrl}/suppliers/findbyid?id=${ID}&locationid=${locationId}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("Response:------------121", res.data.ResponseData);
        setSupplierDetails(res.data.ResponseData.Items[0]);
        setQuickBookId(res.data.ResponseData.Items[0].QuickBookId);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleSubmit1 = () => {
    // console.log( "sonu")
    axios
      .post(
        `${config.suppliersBaseUrl}/suppliers/updatecomments`,
        commentandnotes,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // navigate("/customers");
          navigate(-1);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);

        // backtopreviouspage();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  console.log(supplierdetails, "supplierdetails 162");

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h3 className="page-title">Supplier</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/suppliers">Suppliers List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Supplier</li>
              </ul>
              {/* </div> */}
            </div>
          </div>
              {!QuickBookVendors && AllowQBSync && (
                <QuickbookSyncMessageComponent type="Suppliers" />
              )}
          {paramObject.id > 0 && (
            <div
              style={{
                // border: "1px solid black",
                padding: "10px",
                display: "flex",
                justifyContent: "space-between",
                borderRadius: "15px",
                backgroundColor: "#ffffff",
                // columnGap: "21px",
                // marginBottom: "15px",
              }}
            >
              <div
                style={{
                  padding: "10px",
                  display: "flex",
                  alignItems: "center",

                  // border: "1px solid rgba(107, 108, 114, 0.61)",
                  // borderRadius: "4px",
                  // boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
                  // width: "78%",
                  // backgroundColor: "white",
                }}
              >
                <div
                  style={{
                    // border:'1px solid black',
                    display: "flex",
                    width: "50px",
                    height: "50px",
                    margin: "10px",
                  }}
                >
                  <img
                    src={supplierdetails?.SelectImage}
                    alt={supplierdetails?.FirstName}
                    // width="50px"
                    // height="50px"
                    style={{ borderRadius: "50%" }}
                    onError={(e) => {
                      e.target.src = Noimage;
                    }}
                  />
                </div>
                <div>
                  {/* <h2>{supplierdetails?.CompanyName}</h2> */}
                  <p className="p-lg">
                    {supplierdetails?.FirstName +
                      " " +
                      supplierdetails?.LastName}
                  </p>
                  <p
                    style={{ fontWeight: "800" }}
                    className="mt-2 fs-5 font-weight-bold"
                  >
                    Company Name : {supplierdetails?.CompanyName}
                  </p>

                  <p style={{ fontSize: "14px" }} className="mt-2">
                    {supplierdetails?.Address1 || ""}
                    {supplierdetails?.Address2
                      ? `${supplierdetails.Address2}`
                      : ""}
                    {supplierdetails?.City ? `, ${supplierdetails.City}` : ""}
                    {supplierdetails?.State ? `, ${supplierdetails.State}` : ""}
                    {supplierdetails?.Zip ? ` ${supplierdetails.Zip}` : ""}
                    {supplierdetails?.Country
                      ? `, ${supplierdetails.Country}`
                      : ""}
                  </p>
                </div>
              </div>
              <div
                style={{
                  // padding: "20px",
                  display: "flex",
                  // borderRadius: "4px",
                  // boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
                  // width: "20%",
                  // backgroundColor: "white",
                }}
              >
                <div style={{ padding: "5px 15px", margin: "14px" }}>
                  <p className="p">
                  {CurrencySymbols(
                          Number(supplierdetails?.OpenBalance),
                           { CurrencySymbol },
                          FractionDigits
                        )}
                    {/* $
                    {Number(supplierdetails?.OpenBalance).toLocaleString(
                      "en-US",
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )} */}
                  </p>
                  <p className="p-medium">
                    {/* Open balance */}
                    Open Balance
                  </p>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    padding: "5px 15px",
                    margin: "14px",
                  }}
                >
                  <p className="p">
                    {/* ${parseFloat(supplierdetails?.BalanceCredit).toFixed(2)} */}
                    {/* $
                    {Number(supplierdetails?.BalanceCredit).toLocaleString(
                      "en-US",
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )} */}
                         {CurrencySymbols(
                          Number(supplierdetails?.BalanceCredit),
                           { CurrencySymbol },
                          FractionDigits
                        )}
                  </p>
                  <p className="p-medium">
                    {/* Open balance */}
                    Credit Balance
                  </p>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    padding: "5px 15px",
                    margin: "14px",
                  }}
                >
                  <p className="p">
                    {/* {supplierdetails?.OverduePayment == null
                      ? `$${parseFloat(0).toFixed(2)}`
                      : `$${Number(
                          supplierdetails?.OverduePayment
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`} */}
                             {CurrencySymbols(
                          Number(supplierdetails?.OverduePayment == null ? 0 : supplierdetails?.OverduePayment),
                           { CurrencySymbol },
                          FractionDigits
                        )}
                  </p>
                  <p className="p-medium">Overdue payment</p>
                </div>
              </div>
            </div>
          )}

          {ID === undefined ? (
            <div>{<SupplierFormData />}</div>
          ) : (
            <div className="">
              <div
                className="nav nav-pills"
                style={{ display: "flex", gap: "10px", margin: "1rem 0" }}
              >
                <li className="nav-item" onClick={() => handleToggle(4)}>
                  <a
                    // className="nav-link active"
                    className="btn btn-sm new-btn-customer nav-link1"
                    data-bs-toggle="pill"
                    role="tab"
                    href="javascript:void(0);"
                  >
                    <i className="fa fa-check mr-2" aria-hidden="true"></i>{" "}
                    Transaction
                  </a>
                </li>

                <li
                  className="nav-item"
                  onClick={() => {
                    setSupplier(true);
                    setStatement(false);
                    setReceivingData(false);
                    setPayBillsData(false);
                    setComment(false);
                    setInternalNotes(false);
                  }}
                >
                  <a
                    className="btn btn-sm new-btn-customer nav-link1"
                    data-bs-toggle="pill"
                    role="tab"
                    href="javascript:void(0);"
                  >
                    <i className="fa fa-user mr-2" aria-hidden="true"></i>{" "}
                    Supplier Information
                  </a>
                </li>
                <li className="nav-item" onClick={() => handleStatement()}>
                  <a
                    className="btn btn-sm new-btn-customer nav-link1"
                    data-bs-toggle="pill"
                    role="tab"
                    href="javascript:void(0);"
                  >
                    <i className="fa fa-solid fa-money-bill mr-2"></i> Statement
                  </a>
                </li>

                <li class="nav-item" onClick={handleComment}>
                  <a
                    class="btn btn-sm new-btn-customer nav-link1"
                    href="javascript:void(0);"
                    data-bs-toggle="pill"
                    role="tab"
                  >
                    <i class="fa fa-comment-o mr-2" aria-hidden="true"></i>{" "}
                    Comments
                  </a>
                </li>
                <li class="nav-item" onClick={handleNotes}>
                  <a
                    class="btn btn-sm new-btn-customer nav-link1"
                    href="javascript:void(0);"
                    data-bs-toggle="pill"
                    role="tab"
                  >
                    <i class="fa fa-sticky-note-o mr-2" aria-hidden="true"></i>{" "}
                    Internal Notes
                  </a>
                </li>

                {/* <li className="nav-item" onClick={() => handleToggle(2)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-check" aria-hidden="true"></i>
                      <span>Receiving</span>
                    </a>
                  </li> */}
                {/* <li className="nav-item" onClick={() => handleToggle(7)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-check" aria-hidden="true"></i>
                      <span>Expense</span>
                    </a>
                  </li> */}
                {/* <li className="nav-item" onClick={() => handleToggle(1)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-first-order" aria-hidden="true"></i>
                      <span>Purchase Order</span>
                    </a>
                  </li> */}
                {/* <li className="nav-item" onClick={() => handleToggle(5)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-solid fa-credit-card"></i>
                      <span>Vendor Credit</span>
                    </a>
                  </li> */}
                {/* <li className="nav-item" onClick={() => handleToggle(3)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-solid fa-credit-card"></i>
                      <span>Supplier Return</span>
                    </a>
                  </li> */}
                {/* <li className="nav-item" onClick={() => handleToggle(6)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-folder-open" aria-hidden="true"></i>
                      <span>Wallet Logs</span>
                    </a>
                  </li> */}
                {/* <li className="nav-item" onClick={() => handleClick()}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-solid fa-money-bill"></i>
                      <span>Paid Bills</span>
                    </a>
                  </li> */}
              </div>

              {comment ? (
                <div className="">
                  <div className="card bg-white">
                    {/* <div className="row m-3"> */}
                    {/* <div className="col-sm-12"> */}
                    <div className="form-group col">
                      <h5 className="card-title">Comments</h5>
                      <div className="col-md-12">
                        {showErrorOfLength && (
                          <p style={{ color: "red" }}>
                            *Comment Character Count Exceeds 255 Characters
                          </p>
                        )}
                        <textarea
                          as="textarea"
                          maxLength={255}
                          className="form-control h-100 w-100"
                          // id="exampleFormControlTextarea1"
                          rows="10"
                          defaultValue={supplierdetails.Comments}
                          onChange={handleCommentAndNotes}
                          id="Comments"
                          name="COMMENTS"
                        />
                      </div>
                    </div>
                    {/* </div> */}

                    {/* </div> */}
                  </div>

                  <div>
                    <div className="pull-right ">
                      <button
                        onClick={handleSubmit1}
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                      <div
                        onClick={() => navigate(-1)}
                        // className="btn btn-secondary mb-3 pr-3"
                        className="btn btn-dark btn-md me-1 pull-right"
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {internalnotes ? (
                <div className="">
                  <div className="card bg-white">
                    {/* <div className="row m-3">
<div className="col-sm-12"> */}
                    <div className="form-group col">
                      <h5 className="card-title">Internal Notes</h5>
                      <div className="col-md-12 ">
                        {showErrorOfLengthNote && (
                          <p style={{ color: "red" }}>
                            *Note Character Count Exceeds 255 Characters
                          </p>
                        )}
                        <textarea
                          as="textarea"
                          className="form-control h-100 w-100"
                          maxLength={255}
                          // onChange={handleChange}
                          onChange={handleCommentAndNotes}
                          id="InternalNotes"
                          defaultValue={supplierdetails.Internalnotes}
                          // name="InternalNotes"
                          rows="10"
                          name="NOTES"
                        />
                      </div>
                    </div>
                  </div>
                  {/* </div>
</div> */}

                  <div>
                    <div className="pull-right ">
                      <button
                        // type="submit"
                        onClick={handleSubmit1}
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                      <div
                        // onClick={backtopreviouspage}
                        onClick={() => navigate(-1)}
                        className="btn btn-dark btn-md me-1 pull-right "
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {supplier === true ? <SupplierFormData /> : ""}

              {payBillsData === true ? (
                <PayBillsEditData supplierid={ID} />
              ) : (
                ""
              )}


<MissingTransaction value ={missingtransactions}/>

              {receivingData === true ? (
                <SupplierEditData
                  // receivingTypeID={receivingListId}
                  supplierID={ID}
                  supplierAccount={receivingListId}
                />
              ) : (
                ""
              )}

              {statement === true ? <SupplierStatement /> : ""}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ManageSuppliers;

// {comment ? <><div className="col-lg-10 col-md-12">
// <div className="card bg-white">
// <div className="row m-3">
//                           <div className="col-sm-12">
//                             <div className="form-group row">
//                               <label className="col-form-label col-md-2 form-label">
//                                 Comments
//                               </label>
//                               <div className="col-md-8">
//                                 <textarea
//                                   as="textarea"

//                                   className="form-control h-100 "
//                                   // id="exampleFormControlTextarea1"
//                                   rows="10"
//                                   // onChange={handleChange}
//                                   id="Comments"
//                                   name="Comments"
//                                 />
//                               </div>
//                             </div>
//                           </div>

// </div>
// </div>
// </div> : ""}
// {internalnotes ?  <div className="row m-3">
// <div className="col-sm-12">
//                               <div className="form-group row">
//                                 <label className="col-form-label col-md-2 form-label">
//                                   Internal Notes
//                                 </label>
//                                 <div className="col-md-8 ">
//                                   <textarea
//                                     as="textarea"
//                                     className="form-control h-100"
//                                     // onChange={handleChange}
//                                     id="InternalNotes"
//                                     name="InternalNotes"
//                                     rows="10"
//                                   />
//                                 </div>
//                               </div>
//                             </div>
// </div>: ""}
